import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const RulerIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#00598E"
      strokeWidth="0.5"
      {...props}
    >
      <path
        d="M19 17.75H5C2.58 17.75 1.25 16.42 1.25 14V10C1.25 7.58 2.58 6.25 5 6.25H19C21.42 6.25 22.75 7.58 22.75 10V14C22.75 16.42 21.42 17.75 19 17.75ZM5 7.75C3.42 7.75 2.75 8.42 2.75 10V14C2.75 15.58 3.42 16.25 5 16.25H19C20.58 16.25 21.25 15.58 21.25 14V10C21.25 8.42 20.58 7.75 19 7.75H5Z"

      />
      <path
        d="M18 12.75C17.59 12.75 17.25 12.41 17.25 12V7C17.25 6.59 17.59 6.25 18 6.25C18.41 6.25 18.75 6.59 18.75 7V12C18.75 12.41 18.41 12.75 18 12.75Z"

      />
      <path
        d="M6 11.75C5.59 11.75 5.25 11.41 5.25 11V7C5.25 6.59 5.59 6.25 6 6.25C6.41 6.25 6.75 6.59 6.75 7V11C6.75 11.41 6.41 11.75 6 11.75Z"

      />
      <path
        d="M10 12.75C9.58 12.75 9.25 12.41 9.25 11.99L9.3 6.99C9.3 6.58 9.64 6.25 10.05 6.25C10.05 6.25 10.05 6.25 10.06 6.25C10.47 6.25 10.81 6.59 10.8 7.01L10.75 12.01C10.75 12.42 10.41 12.75 10 12.75Z"

      />
      <path
        d="M14 10.75C13.59 10.75 13.25 10.41 13.25 10V7C13.25 6.59 13.59 6.25 14 6.25C14.41 6.25 14.75 6.59 14.75 7V10C14.75 10.41 14.41 10.75 14 10.75Z"

      />
    </SvgIcon>
  )
}
